export const formSchema = {
	type: "object",
	required: [
		"type",
		"name",
		"company",
		"model",
		"year",
		"color"
	],
	properties: {
		type: {
			type: "string",
			title: "Type",
			enum: ['Equipment', 'Hand Tool', 'Generators']
		},
		name: {
			type: "string",
			title: "Name",
			maxLength: 256
		},
		company: {
			type: "string",
			title: "Make",
			maxLength: 100
		},
		model: {
			type: "string",
			title: "Model",
			maxLength: 50
		},
		year: {
			type: "number",
			title: "Year",
			maxLength: 4,
			default: 20
		},
		color: {
			type: "string",
			title: "Color",
			maxLength: 10
		}
	}
};

export const uiSchema = {
	type: {
		"ui:autofocus": true,
	},
	year: {
		"ui:widget": "updown",
	}
};
